(function () {
  'use strict';

  // ── State ──────────────────────────────────────────────────────────────────
  var root;
  var currentConfig = null;
  var selectedPhotoFile = null;   // File — from camera capture or gallery pick
  var selectedPhotoSource = null; // 'camera' | 'gallery'
  var selectedPhotoThumbUrl = null; // object URL, revoked on change/reset
  var camStream = null;
  var cameraConsentGiven = false; // reset per PD-flow open(); camera access is gated on this
  var uploadConsentGiven = false; // reset per PD-flow open(); gallery upload is gated on this

  var steps = {
    prep: null, photo: null, consentCamera: null, consentUpload: null, camera: null, manual: null
  };

  // Prep demo video — only actually starts playing once the 'prep' step is
  // shown (the whole PD sub-flow lives inside a display:none root until then,
  // so starting playback earlier would burn through the 3 auto-plays unseen).
  var demoVideo = null;
  var demoVideoWrap = null;
  var demoPlaysRemaining = 0;

  function startPrepVideo() {
    if (!demoVideo) return;
    demoPlaysRemaining = 3;
    if (demoVideoWrap) demoVideoWrap.classList.remove('bd-pd-position-video--paused');
    demoVideo.currentTime = 0;
    demoVideo.play().catch(function () {});
  }

  function showStep(name) {
    Object.keys(steps).forEach(function (k) {
      var el = steps[k];
      if (el) el.style.display = k === name ? '' : 'none';
    });
    var active = steps[name];
    if (active) active.scrollTop = 0;
    if (name === 'prep') startPrepVideo();
    else if (demoVideo) demoVideo.pause();
  }

  // ── Camera (live capture, no face/card detection — just a shutter) ───────

  function stopCamera() {
    if (camStream) { camStream.getTracks().forEach(function (t) { t.stop(); }); camStream = null; }
  }

  function startCamera() {
    var video = document.getElementById('bdPdCamVideo');
    var errorBox = document.getElementById('bdPdCameraError');
    var shutter = document.getElementById('bdPdCamShutter');
    if (errorBox) errorBox.style.display = 'none';
    if (video) video.style.display = '';
    if (shutter) shutter.disabled = true;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      if (errorBox) errorBox.style.display = 'flex';
      if (video) video.style.display = 'none';
      return;
    }
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false })
      .then(function (stream) {
        camStream = stream;
        if (!video) return;
        video.srcObject = stream;
        video.play();
        if (shutter) shutter.disabled = false;
      })
      .catch(function () {
        if (errorBox) errorBox.style.display = 'flex';
        if (video) video.style.display = 'none';
      });
  }

  // Burn L/R markers into the frame edges so staff always know which side is
  // which, regardless of how a given browser/device might (not) mirror the
  // front camera. The live preview here is never CSS-mirrored (no transform
  // on #bdPdCamVideo), so what's drawn onto the canvas below — labels
  // included — is exactly what ends up in the saved photo.
  function drawOrientationLabels(ctx, w, h) {
    var pad = Math.round(w * 0.035);
    var fontSize = Math.max(22, Math.round(w * 0.05));
    ctx.font = 'bold ' + fontSize + 'px sans-serif';
    ctx.textBaseline = 'top';
    ctx.lineWidth = Math.max(3, fontSize * 0.16);
    ctx.strokeStyle = 'rgba(0,0,0,0.7)';
    ctx.fillStyle = '#FFD93D';
    ctx.textAlign = 'left';
    ctx.strokeText('L', pad, pad);
    ctx.fillText('L', pad, pad);
    ctx.textAlign = 'right';
    ctx.strokeText('R', w - pad, pad);
    ctx.fillText('R', w - pad, pad);
  }

  function captureFromCamera() {
    var video = document.getElementById('bdPdCamVideo');
    var canvas = document.getElementById('bdPdCamCanvas');
    if (!video || !canvas || !video.videoWidth) return;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    drawOrientationLabels(ctx, canvas.width, canvas.height);
    canvas.toBlob(function (blob) {
      if (!blob) return;
      selectedPhotoFile = new File([blob], 'pd-kamera-foto.jpg', { type: 'image/jpeg' });
      selectedPhotoSource = 'camera';
      stopCamera();
      updatePhotoZones();
      showStep('photo');
    }, 'image/jpeg', 0.92);
  }

  // ── Photo step (camera-zone trigger + gallery-zone file input) ───────────

  function updatePhotoZones() {
    var camIcon   = document.getElementById('bdPdCameraIcon');
    var camThumb  = document.getElementById('bdPdCameraThumb');
    var camLabel  = document.getElementById('bdPdCameraLabel');
    var camSub    = document.getElementById('bdPdCameraSub');
    var camRetake = document.getElementById('bdPdCameraRetake');

    var galIcon  = document.getElementById('bdPdGalleryIcon');
    var galThumb = document.getElementById('bdPdGalleryThumb');
    var galLabel = document.getElementById('bdPdGalleryLabel');
    var galSub   = document.getElementById('bdPdGallerySub');

    var next = document.getElementById('bdPdPhotoNext');

    if (selectedPhotoThumbUrl) { URL.revokeObjectURL(selectedPhotoThumbUrl); selectedPhotoThumbUrl = null; }

    var isCam = selectedPhotoSource === 'camera';
    var isGal = selectedPhotoSource === 'gallery';

    if (isCam || isGal) selectedPhotoThumbUrl = URL.createObjectURL(selectedPhotoFile);

    if (camIcon)   camIcon.style.display  = isCam ? 'none' : '';
    if (camThumb)  { camThumb.src = isCam ? selectedPhotoThumbUrl : ''; camThumb.style.display = isCam ? 'block' : 'none'; }
    if (camLabel)  {
      camLabel.textContent = isCam ? bdT('photo_taken', 'Foto wurde aufgenommen ✓') : bdT('take_photo', 'Foto aufnehmen');
      camLabel.classList.toggle('bd-upload-zone__label--success', isCam);
    }
    if (camSub)    camSub.textContent   = isCam ? bdT('photo_ok', 'Sieht gut aus? Weiter unten fortfahren') : bdT('open_camera', 'Kamera direkt öffnen');
    if (camRetake) camRetake.style.display = isCam ? 'block' : 'none';

    if (galIcon)  galIcon.style.display  = isGal ? 'none' : '';
    if (galThumb) { galThumb.src = isGal ? selectedPhotoThumbUrl : ''; galThumb.style.display = isGal ? 'block' : 'none'; }
    if (galLabel) {
      galLabel.textContent = isGal ? bdT('photo_selected', 'Foto ausgewählt ✓') : bdT('upload_existing', 'Bestehendes Foto hochladen');
      galLabel.classList.toggle('bd-upload-zone__label--success', isGal);
    }
    if (galSub)   galSub.textContent   = isGal ? (selectedPhotoFile.name || bdT('change_hint', 'Zum Ändern erneut klicken')) : bdT('file_types', 'JPG oder PNG · max. 10 MB');

    if (next) next.disabled = !selectedPhotoFile;
  }

  function confirmPhoto() {
    if (!selectedPhotoFile || !currentConfig) { close(); return; }
    if (typeof currentConfig.onPhotoAttached === 'function') {
      // Hand off a detached <input> (via DataTransfer) so it can be moved
      // into the host's <form> without touching anything inside bdPdStepsRoot.
      var dt = new DataTransfer();
      dt.items.add(selectedPhotoFile);
      var detached = document.createElement('input');
      detached.type = 'file';
      detached.files = dt.files;
      currentConfig.onPhotoAttached(detached);
    }
    if (currentConfig.confirmNoteEl) {
      currentConfig.confirmNoteEl.textContent = bdT('pd_photo_uploaded', 'PD-Foto hochgeladen — wir lesen den Wert aus und tragen ihn nach ✓');
      currentConfig.confirmNoteEl.style.display = 'block';
    }
    close();
  }

  // ── Manual ─────────────────────────────────────────────────────────────────

  function confirmManual() {
    var tVal = parseFloat((document.getElementById('bdPdManualTotal') || {}).value);
    var rVal = parseFloat((document.getElementById('bdPdManualRight') || {}).value);
    var lVal = parseFloat((document.getElementById('bdPdManualLeft') || {}).value);
    var errEl = document.getElementById('bdPdManualError');
    var pdR, pdL;

    if (!isNaN(tVal) && tVal >= 35 && tVal <= 80) {
      pdR = pdL = tVal / 2;
    } else if (!isNaN(rVal) && !isNaN(lVal) && rVal >= 17.5 && rVal <= 40 && lVal >= 17.5 && lVal <= 40) {
      pdR = rVal; pdL = lVal;
    } else {
      if (errEl) errEl.style.display = 'flex';
      return;
    }
    if (errEl) errEl.style.display = 'none';
    pdR = Math.round(pdR * 2) / 2;
    pdL = Math.round(pdL * 2) / 2;

    if (!currentConfig || !currentConfig.fieldIds) { close(); return; }
    var elR = document.getElementById(currentConfig.fieldIds.r);
    var elL = document.getElementById(currentConfig.fieldIds.l);
    [[elR, pdR], [elL, pdL]].forEach(function (pair) {
      var el = pair[0], val = pair[1];
      if (!el) return;
      el.value = val.toFixed(1);
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (currentConfig.confirmNoteEl) {
      currentConfig.confirmNoteEl.textContent = bdT('pd_applied', 'PD übernommen: [r] / [l] mm ✓', { r: pdR.toFixed(1), l: pdL.toFixed(1) });
      currentConfig.confirmNoteEl.style.display = 'block';
    }
    if (typeof currentConfig.onManualConfirmed === 'function') currentConfig.onManualConfirmed();
    close();
  }

  // ── Open / close as a sub-step of the host Rx modal ───────────────────────
  // manualBackTarget: which step "← Zurück" in the manual step returns to.
  // When opened with startStep:'manual' (host already knows PD is "known",
  // e.g. from its own chooser step) there's no 'prep' to go back to — back
  // should just close the whole PD sub-flow instead.
  var manualBackTarget = 'prep';

  function open(config) {
    if (!root) return;
    currentConfig = config || {};
    resetAll();
    if (currentConfig.hostPanel) currentConfig.hostPanel.appendChild(root);
    // display:contents keeps .bd-step children as direct flex items of the
    // host .bd-modal__panel (flex-direction:column) — a plain block wrapper
    // here would break their flex:1 sizing and could clip them out of view.
    root.style.display = 'contents';
    if (currentConfig.currentStepEl) currentConfig.currentStepEl.style.display = 'none';
    var start = currentConfig.startStep || 'prep';
    manualBackTarget = (start === 'manual') ? null : 'prep';
    showStep(start);
  }

  function close() {
    stopCamera();
    if (root) root.style.display = 'none';
    if (currentConfig && currentConfig.currentStepEl) currentConfig.currentStepEl.style.display = '';
    currentConfig = null;
  }

  function resetAll() {
    stopCamera();
    selectedPhotoFile = null;
    selectedPhotoSource = null;
    if (selectedPhotoThumbUrl) { URL.revokeObjectURL(selectedPhotoThumbUrl); selectedPhotoThumbUrl = null; }

    cameraConsentGiven = false;
    var camConsentCb = document.getElementById('bdPdConsentCameraCheckbox');
    if (camConsentCb) camConsentCb.checked = false;
    var camConsentNextBtn = document.getElementById('bdPdConsentCameraNext');
    if (camConsentNextBtn) camConsentNextBtn.disabled = true;

    uploadConsentGiven = false;
    var upConsentCb = document.getElementById('bdPdConsentUploadCheckbox');
    if (upConsentCb) upConsentCb.checked = false;
    var upConsentNextBtn = document.getElementById('bdPdConsentUploadNext');
    if (upConsentNextBtn) upConsentNextBtn.disabled = true;

    ['bdPdManualTotal', 'bdPdManualRight', 'bdPdManualLeft'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.value = '';
    });
    var err = document.getElementById('bdPdManualError');
    if (err) err.style.display = 'none';

    var galleryInput = document.getElementById('bdPdGalleryInput');
    if (galleryInput) galleryInput.value = '';

    var camError = document.getElementById('bdPdCameraError');
    if (camError) camError.style.display = 'none';

    updatePhotoZones();
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    root = document.getElementById('bdPdStepsRoot');
    if (!root) return;

    steps.prep   = document.getElementById('bdPdStepPrep');
    steps.photo  = document.getElementById('bdPdStepPhoto');
    steps.consentCamera = document.getElementById('bdPdStepConsentCamera');
    steps.consentUpload = document.getElementById('bdPdStepConsentUpload');
    steps.camera = document.getElementById('bdPdStepCamera');
    steps.manual = document.getElementById('bdPdStepManual');

    // Prep demo video — widescreen clip on desktop, portrait clip on mobile.
    // Source/copy picked once (device orientation won't change mid-session);
    // actual playback only starts once the 'prep' step becomes visible (see
    // showStep/startPrepVideo above).
    demoVideo = document.getElementById('bdPdDemoVideo');
    if (demoVideo) {
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      var src = isDesktop ? demoVideo.dataset.srcDesktop : demoVideo.dataset.srcMobile;
      if (src) demoVideo.src = src;
      demoVideoWrap = document.getElementById('bdPdPositionVideo');
      if (demoVideoWrap) demoVideoWrap.classList.toggle('bd-pd-position-video--wide', isDesktop);

      // Checklist copy must match what the clip actually shows: the mobile
      // clip holds the ruler above the eyes (eyebrow height), the desktop
      // clip holds it just below the eyes.
      var posTitle = document.getElementById('bdPdPositionTitle');
      var posSub   = document.getElementById('bdPdPositionSub');
      var camPosHint = document.getElementById('bdPdCameraPositionHint');
      if (posTitle && posSub) {
        if (isDesktop) {
          posTitle.textContent = bdT('ruler_below', 'Massstab unter die Augen halten');
          posSub.textContent = bdT('ruler_below_hint', 'Direkt unter den Augen, Skala muss gut lesbar sein');
        } else {
          posTitle.textContent = bdT('ruler_hold', 'Massstab über die Augen halten');
          posSub.textContent = bdT('ruler_hold_hint', 'Auf Augenbrauenhöhe, Skala muss gut lesbar sein');
        }
      }
      if (camPosHint) {
        camPosHint.textContent = isDesktop ? bdT('ruler_below', 'Massstab unter die Augen halten') : bdT('hold_ruler_brow', 'Massstab auf Augenbrauenhöhe halten');
      }

      // Auto-play 3 times, then pause on the last frame until the customer
      // taps the clip to watch it 3 more times.
      demoVideo.addEventListener('ended', function () {
        demoPlaysRemaining--;
        if (demoPlaysRemaining > 0) {
          demoVideo.play();
        } else if (demoVideoWrap) {
          demoVideoWrap.classList.add('bd-pd-position-video--paused');
        }
      });
      if (demoVideoWrap) {
        demoVideoWrap.addEventListener('click', function () {
          if (!demoVideoWrap.classList.contains('bd-pd-position-video--paused')) return;
          startPrepVideo();
        });
      }
    }

    // Prep
    var prepBack = document.getElementById('bdPdPrepBack');
    if (prepBack) prepBack.addEventListener('click', close);
    var prepNext = document.getElementById('bdPdPrepNext');
    if (prepNext) prepNext.addEventListener('click', function () { showStep('photo'); });
    var manualEntryBtn = document.getElementById('bdPdManualEntryBtn');
    if (manualEntryBtn) manualEntryBtn.addEventListener('click', function () { showStep('manual'); });

    // Photo
    var cameraZoneBtn  = document.getElementById('bdPdCameraZoneBtn');
    var cameraRetake   = document.getElementById('bdPdCameraRetake');
    var galleryZoneBtn = document.getElementById('bdPdGalleryZoneBtn');
    var galleryInput   = document.getElementById('bdPdGalleryInput');

    var openCameraStep = function () {
      if (cameraConsentGiven) { showStep('camera'); startCamera(); }
      else { showStep('consentCamera'); }
    };
    if (cameraZoneBtn) cameraZoneBtn.addEventListener('click', openCameraStep);
    if (cameraRetake) cameraRetake.addEventListener('click', openCameraStep);

    var openGalleryPicker = function () {
      if (uploadConsentGiven) { galleryInput.click(); }
      else { showStep('consentUpload'); }
    };
    if (galleryZoneBtn) galleryZoneBtn.addEventListener('click', openGalleryPicker);

    // Consent — camera (gates live capture, asked once per PD-flow open())
    var camConsentCheckbox = document.getElementById('bdPdConsentCameraCheckbox');
    var camConsentNext     = document.getElementById('bdPdConsentCameraNext');
    var camConsentBack     = document.getElementById('bdPdConsentCameraBack');
    if (camConsentCheckbox) camConsentCheckbox.addEventListener('change', function () {
      if (camConsentNext) camConsentNext.disabled = !camConsentCheckbox.checked;
    });
    if (camConsentNext) camConsentNext.addEventListener('click', function () {
      if (!camConsentCheckbox || !camConsentCheckbox.checked) return;
      cameraConsentGiven = true;
      showStep('camera');
      startCamera();
    });
    if (camConsentBack) camConsentBack.addEventListener('click', function () { showStep('photo'); });

    // Consent — upload (gates gallery picker, asked once per PD-flow open())
    var upConsentCheckbox = document.getElementById('bdPdConsentUploadCheckbox');
    var upConsentNext     = document.getElementById('bdPdConsentUploadNext');
    var upConsentBack     = document.getElementById('bdPdConsentUploadBack');
    if (upConsentCheckbox) upConsentCheckbox.addEventListener('change', function () {
      if (upConsentNext) upConsentNext.disabled = !upConsentCheckbox.checked;
    });
    if (upConsentNext) upConsentNext.addEventListener('click', function () {
      if (!upConsentCheckbox || !upConsentCheckbox.checked) return;
      uploadConsentGiven = true;
      showStep('photo');
      galleryInput.click();
    });
    if (upConsentBack) upConsentBack.addEventListener('click', function () { showStep('photo'); });

    if (galleryInput) galleryInput.addEventListener('change', function () {
      var file = galleryInput.files && galleryInput.files[0];
      if (!file) return;
      selectedPhotoFile = file;
      selectedPhotoSource = 'gallery';
      updatePhotoZones();
    });
    var photoBack = document.getElementById('bdPdPhotoBack');
    if (photoBack) photoBack.addEventListener('click', function () { showStep('prep'); });
    var photoNext = document.getElementById('bdPdPhotoNext');
    if (photoNext) photoNext.addEventListener('click', confirmPhoto);

    // Camera
    var camBack = document.getElementById('bdPdCamBack');
    if (camBack) camBack.addEventListener('click', function () { stopCamera(); showStep('photo'); });
    var camShutter = document.getElementById('bdPdCamShutter');
    if (camShutter) camShutter.addEventListener('click', captureFromCamera);
    var camErrorFallback = document.getElementById('bdPdCameraErrorFallback');
    if (camErrorFallback) camErrorFallback.addEventListener('click', function () {
      stopCamera();
      showStep('photo');
      openGalleryPicker();
    });

    // Manual
    var manBack = document.getElementById('bdPdManualBack');
    if (manBack) manBack.addEventListener('click', function () {
      if (manualBackTarget) showStep(manualBackTarget); else close();
    });
    var manConf = document.getElementById('bdPdManualConfirm');
    if (manConf) manConf.addEventListener('click', confirmManual);
  });

  window.BdPd = { open: open, close: close };
})();
